import { StreamingService } from 'src/app/services/streaming.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConstantsService } from 'src/app/services/constants.service';

export interface IConfirmModalData {
  scheldules: any;
}

@Component({
  selector: 'app-popup-order-and-entry',
  templateUrl: './popup-order-and-entry.component.html',
  styleUrls: ['./popup-order-and-entry.component.scss'],
})
export class PopupOrderAndEntryComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IConfirmModalData,
    private streaming: StreamingService
  ) {}

  animals: any = [];
  loading = false;

  ngOnInit() {
    this.entranceOrder();
  }

  entranceOrder() {
    this.loading = true;

    this.streaming.entranceOrder(this.data.scheldules.id).subscribe({
      next:  (data) => {
        this.animals = this.orderList(data);
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  orderList(list: any[]) {
    return list.sort((a, b) => {
      const statusA = a.entrance_order;
      const statusB = b.entrance_order;

      if (statusA < statusB) {
        return -1;
      }
      if (statusA > statusB) {
        return 1;
      }
      return 0;
    });
  }
}
